// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: 18,
        paginationTypeAdvanced: true
        /* Optional */
        //loadProductFirst: true,
    },
    template: {
      filterOptionWrapper: '<div class="{{class.filterOption}} {{blockTypeClass}} {{blockId}}"><div class="{{class.filterBlockTitle}}"><h3><span>{{blockTitle}}</span></h3>{{tooltip}}{{clearButton}}</div>{{filterBlockShowSearchBox}}<div class="{{class.filterBlockContent}}"><div class="second-title"><h3><span>{{blockTitle}}</span></h3><span class="bc-close"></span></div>{{blockContent}}</div></div>',
    }
   };

// Declare Templates
var bcSfFilterTemplate = {
    'soldOutClass': 'sold-out',
    'saleClass': 'on-sale',
    'soldOutLabelHtml': '<div class="grid-product__sold-out"><p>' + bcSfFilterConfig.label.sold_out + '</p></div>',
    'saleLabelHtml': '<div class="grid-product__on-sale"><p>' + bcSfFilterConfig.label.sale + '</p></div>',
    'vendorHtml': '{{itemVendorLabel}}',

 // Grid Template
    'productGridItemHtml': '<div class="grid__item grid-product bc-sf-filter-product-item   medium--one-half large--one-third small--one-half   is-sold-out">' +
                                '<div class="grid-product__wrapper {{soldOutClass}} {{saleClass}}">' +
                                    '<div class="grid-product__image-wrapper">' +
                                        '{{itemImages}}' +
                                        '{{itemSizesTag}}' +
                                        '{{itemSaleLabel}}' +
                                        '{{itemSoldOutLabel}}' +
                                    '</div>' +
                                    '{{itemWaitListLabel}}' +
                                    '<a href="{{itemUrl}}" class="grid-product__meta">' +
                                      '<p class="feature-product__title"><span class="grid-collection__title">{{itemVendor}}</span></p>' +
                                      '<p class="feature-product__title"><span class="grid-product__title">{{itemTitle}}</span></p>' +
                                      '{{itemPrice}}' +
                                    '</a>' +
                                '</div>' +                  
                            '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul>',
  
    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="collection-sort__input">{{sortingItems}}</select>',
};

/************************** BUILD PRODUCT LIST **************************/

// Build Product Grid Item
BCSfFilter.prototype.buildProductGridItem = function(data, index) {
  /*** Prepare data ***/
  var images = data.images_info;
  var soldOut = !data.available; // Check a product is out of stock
  var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  var priceVaries = data.price_min != data.price_max; // Check a product has many prices
  // Get First Variant (selected_or_first_available_variant)
  var firstVariant = data['variants'][0];
  if (getParam('variant') !== null && getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) { return e.id == getParam('variant'); });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
  /*** End Prepare data ***/

  // Get Template
  var itemHtml = bcSfFilterTemplate.productGridItemHtml;

  // Add Thumbnail
  var itemThumbUrl = images.length > 0 ? this.optimizeImage(images[0]['src']) : bcSfFilterConfig.general.no_image_url;
  itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

  // Add Price
  var itemPriceHtml = '';
  if (data.tags.indexOf("no_price") !== -1) {
    itemPriceHtml = '';
  } else {
    if (data.title != '') {
      itemPriceHtml += '<span class="grid-product__price-wrap productrelatedprice"><span class="grid-product__price">';
      if (onSale) {
        itemPriceHtml += '<s class="grid-link__sale_price">' + this.formatMoney(data.compare_at_price_min) + '</s> ';
      }
      if (priceVaries) {
        //itemPriceHtml += (bcSfFilterConfig.label.from_price).replace(/{{ price }}/g, this.formatMoney(data.price_min));
      	itemPriceHtml += this.formatMoney(data.price_min);
      } else {
        itemPriceHtml += this.formatMoney(data.price_min);
      }
      itemPriceHtml += '</span></span>';

    }
  }
  itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

  // Add soldOut class
  var soldOutClass = soldOut ? bcSfFilterTemplate.soldOutClass : '';
  itemHtml = itemHtml.replace(/{{soldOutClass}}/g, soldOutClass);

  // Add onSale class
  var saleClass = onSale ? bcSfFilterTemplate.saleClass : '';
  itemHtml = itemHtml.replace(/{{saleClass}}/g, saleClass);

  // Add soldOut Label
  var itemSoldOutLabelHtml = soldOut ? bcSfFilterTemplate.soldOutLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabelHtml);

  // Add onSale Label
  var itemSaleLabelHtml = onSale ? bcSfFilterTemplate.saleLabelHtml : '';
  itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabelHtml);

  // Add Vendor
  var itemVendorHtml = bcSfFilterConfig.custom.product_vendor_enable ? bcSfFilterTemplate.vendorHtml.replace(/{{itemVendorLabel}}/g, data.vendor) : '';
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);


  // Build Image style
  var imageStyle = buildImageStyle(data);
  itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

  // Add item image
  var itemImagesHtml = '';

  itemImagesHtml += '<a class="grid-product__image-link" href="{{itemUrl}}">';
  if (images != null && images.length > 0) {

    var imgWrapperId = 'ProductImageWrapper-' + data.images_info[0].id;
    var imgIdClass = 'ProductImage-' + data.images_info[0].id;
    var itemThumbUrl = this.optimizeImage(images[0]['src'], '1x1').replace('_1x1.', '_{width}x.');
    var aspectRatio = images[0]['height'] / images[0]['width'];

    itemImagesHtml += '<div id="' + imgWrapperId + '" class="product--wrapper grid__item firstimage">' +
      '<div style="padding-top:' + aspectRatio * 100 + '%;">' +
      '<img class="firstimage product--image lazyload ' + imgIdClass + '"' +
      'src="' + this.optimizeImage(images[0]['src'], '150x150') + '"' +
      'data-src="' + itemThumbUrl + '"' +
      'data-widths="[180, 370, 590, 740, 900, 1080, 1296, 1512, 1728, 2048]"' +
      'data-aspectratio="' + aspectRatio + '"' +
      'data-sizes="auto"' +
      'alt="{{itemTitle}}">' +
      buildImageStyle(data);
    if (data.images[1] != null) {
      var secondimageUrl = this.optimizeImage(images[1]['src'], 'large');
      var imgUrl = this.optimizeImage(images[1]['src'], '1x1').replace('_1x1.', '_{width}x.');

    } else {
      var secondimageUrl = this.optimizeImage(images[0]['src'], 'large');
      var imgUrl = this.optimizeImage(images[0]['src'], '1x1').replace('_1x1.', '_{width}x.');
    }
    if (bcSfFilterConfig.custom.collhover_disbale) {
      itemImagesHtml += '<img class="secondimage product--image lazyload p3limage' + imgIdClass + '"' +
        'src="' + secondimageUrl + '"' +
        'data-src="' + imgUrl + '"' +
        'data-widths="[180, 370, 590, 740, 900, 1080, 1296, 1512, 1728, 2048]"' +
        'data-aspectratio="' + aspectRatio + '"' +
        'data-sizes="auto"' +
        'alt="{{itemTitle}}">';

    }
    itemImagesHtml += '</div></div>';

  } else {
    itemImagesHtml += '<img class="grid-product__image" data-src="' + itemThumbUrl + '" data-sizes="auto" alt="{{itemTitle}}">';

  }

  itemImagesHtml += '</a>';
  itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

  // itemWaitListLabel
  var itemWaitListLabelHtml = '';
  if (soldOut) {
    itemWaitListLabelHtml += '<div class="join-waitlist">' +
      '<span class="joinspan">' +
      "<a href='#' class='BIS_trigger' data-product-data='" + JSON.stringify(data) + "'>" +
      'JOIN WAITLIST' +
      '</a>' +
      '</span>' +
      '</div>';
  }

  itemHtml = itemHtml.replace(/{{itemWaitListLabel}}/g, itemWaitListLabelHtml);

  // Add item SizesTag
  var itemSizesTagHtml = '';
  if (data.tags) {
    for (var i = data.tags.length - 1; i >= 0; i--) {
      tag = data.tags[i];
      if (tag.indexOf("size__") !== -1) {
        var itemSizeName = tag.split('size__')[1];
        itemSizesTagHtml = '<span class="audemars-sizestag">' + itemSizeName + '</span>';
        break;
      }
    }
  }
  itemHtml = itemHtml.replace(/{{itemSizesTag}}/g, itemSizesTagHtml);




  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemTitleCollection}}/g, data.collections[0].title);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));
  

  return itemHtml;
};

// Build Product List Item
BCSfFilter.prototype.buildProductListItem = function(data) {
  // // Add Description
  // var itemDescription = jQ('<p>' + data.body_html + '</p>').text();
  // // Truncate by word
  // itemDescription = (itemDescription.split(" ")).length > 51 ? itemDescription.split(" ").splice(0, 51).join(" ") + '...' : itemDescription.split(" ").splice(0, 51).join(" ");
  // // Truncate by character
  // itemDescription = itemDescription.length > 350 ? itemDescription.substring(0, 350) + '...' : itemDescription.substring(0, 350);
  // itemHtml = itemHtml.replace(/{{itemDescription}}/g, itemDescription);
};

/************************** END BUILD PRODUCT LIST **************************/

function buildImageStyle(data) {
  var images = data.images_info;
  var img_id_class = 'ProductCardImage-{{itemId}}';
  var wrapper_id = 'ProductCardImageWrapper-{{itemId}}';
  var imageStyle = '';
  if (images.length > 0) {
    var image = images[0];
    var width = bcSfFilterConfig.custom.max_height;
    var height = bcSfFilterConfig.custom.max_height;
    var small_style = true;
    var aspect_ratio = image.width / image.height;

    if (aspect_ratio <= 1) {
      var max_width = height * aspect_ratio;
      if (image.height < height) {
        var max_height = image.height;
        var max_width = image.width;
      } else {
        var max_height = height;
      }
    } else {
      var max_height = width / aspect_ratio;
      if (image.width < width) {
        var max_height = image.height;
        var max_width = image.width;
      } else {
        var max_width = width;
      }
    }

    imageStyle += '<style>';
    if (small_style) imageStyle += '@media screen and (min-width: 591px) {';
    imageStyle += '.' + img_id_class + ' {' +
      'max-width: ' + max_width + 'px;' +
      'max-height: ' + max_height + 'px;' +
      '}' +
      '#' + wrapper_id + ' {' +
      'max-width: ' + max_width + 'px;' +
      '}';
    if (small_style) imageStyle += '}';

    if (small_style) {
      if (aspect_ratio <= 1) {
        max_width = 295 * aspect_ratio;
      } else {
        if (image.width < 590) {
          max_width = image.width;
        } else {
          max_width = 590;
        }
      }
      imageStyle += '@media screen and (max-width: 590px) {'
      '.' + img_id_class + '{' +
        'max-width: {{ max_width }}px;' +
        '}' +
        '#' + wrapper_id + '{' +
        'max-width: {{ max_width }}px;' +
        '}' +
        '}';
    }
    imageStyle += '</style>';
  }
  return imageStyle;
}


// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
  if (this.getSettingValue('general.paginationType') == 'default') {
    // Get page info
    var currentPage = parseInt(this.queryParams.page);
    var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

    // If it has only one page, clear Pagination
    if (totalPage == 1) {
      jQ(this.selector.bottomPagination).html('');
      return false;
    }

    if (this.getSettingValue('general.paginationType') == 'default') {
      var paginationHtml = bcSfFilterTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml : bcSfFilterTemplate.nextDisabledHtml;
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

      jQ(this.selector.bottomPagination).html(paginationHtml);
    }
  }
};

/************************** BUILD TOOLBAR **************************/

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function() {
  if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
    jQ(this.selector.topSorting).html('');

    var sortingArr = this.getSortingList();
    if (sortingArr) {
      // Build content 
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
      }
      var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
      jQ(this.selector.topSorting).html(html);

      // Set current value
      jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
    }
  }
};

// Build Display type (List / Grid / Collage)
// BCSfFilter.prototype.buildFilterDisplayType = function() {
//     var itemHtml = '<a href="' + this.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="change-view bc-sf-filter-display-grid" data-view="grid"><span class="icon-fallback-text"><i class="fa fa-th" aria-hidden="true"></i><span class="fallback-text">Grid view</span></span></a>';
//     itemHtml += '<a href="' + this.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="change-view bc-sf-filter-display-list" data-view="list"><span class="icon-fallback-text"><i class="fa fa-list" aria-hidden="true"></i><span class="fallback-text">List view</span></span></a>';
//     jQ(this.selector.topDisplayType).html(itemHtml);

//     // Active current display type
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').removeClass('active');
//     jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').removeClass('active');
//     if (this.queryParams.display == 'list') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-list').addClass('active');
//     } else if (this.queryParams.display == 'grid') {
//         jQ(this.selector.topDisplayType).find('.bc-sf-filter-display-grid').addClass('active');
//     }
// };

/************************** END BUILD TOOLBAR **************************/


// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function(data, eventType) {};

// Build additional elements
BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
  jQ('#bc-sf-filter-tree #bc-sf-filter-options-wrapper .bc-sf-filter-option-block:nth-child(2) .bc-sf-filter-block-title').click(function() {
    jQ(this).toggleClass('bc-sf-toggle-title-option-2');
    jQ('#bc-sf-filter-tree').removeClass('bc-sf-filter-tree-mobile-open');
  })

  // Amount items

  var totalProduct = '';
  if (data.total_product == 1) {
    totalProduct = ' (' + data.total_product + ' item)';
  } else {
    totalProduct = ' (' + data.total_product + ' items)';
  }
  jQ('.bc-sf-amount-top').html(totalProduct);

  // Clode filter

  jQ('#bc-sf-filter-tree .bc-sf-filter-option-block:nth-child(2) .second-title .bc-close').click(function() {
    jQ(this).parents('.bc-sf-filter-option-block').find('.bc-sf-filter-block-title').removeClass('bc-sf-toggle-title-option-2');
  });
  jQ('#bc-sf-filter-tree .bc-sf-filter-option-block:nth-child(3) .second-title .bc-close').click(function() {
    jQ('#bc-sf-filter-tree').removeClass('bc-sf-filter-tree-mobile-open');
  });

  /*
   ** Custom Click Interceptor
   */

  //   jQ(document).find(".grid-product__image-link, .grid-product__meta").on("click", function(e){
  //     e.preventDefault();
  //  var nextPage = jQ(this)[0]["href"];
  //     if(nextPage.includes('/products/')){
  //       var scrollPos = window.pageYOffset;
  //    var queryString = ((window.location.search.length > 0) ? window.location.search + "&productScrollPosition=" + scrollPos : "?productScrollPosition=" + scrollPos);
  //    window.location.href = nextPage + queryString;
  //     }    
  //   });

  /*
   ** End Custom Click Interceptor
   */


  // Add funtion scrollBack
  var productItemSelector = '.grid-product__image-link, .grid-product__meta';
  scrollBack(productItemSelector);

//   if (jQ(window).width() > 767) {
//     $(window).scroll(sticky_relocate);
//     sticky_relocate();
//   }

  // Check filter option length > 3
  // 
  if(jQ('#bc-sf-filter-options-wrapper .bc-sf-filter-option-block').length > 2){
    jQ('#bc-sf-filter-tree-mobile').addClass('has-refine-by-button');
  } else {
    jQ('#bc-sf-filter-tree-mobile').addClass('no-refine-by-button');
    jQ('.bc-sf-collection-sidebar').addClass('no-refine-by-button-header');
  }


  // $('.bc-sf-filter-option-multiple-list').scroll(function () {
  //   var elem = $('.bc-sf-filter-option-multiple-list');
  //   var newScrollLeft = elem.scrollLeft(),
  //       width = elem.width(),
  //       scrollWidth = elem.get(0).scrollWidth;
  //   if ((scrollWidth - newScrollLeft - width) == 0) {
  //       elem.animate( { scrollLeft: '-=460' }, 1000);    }    
  // });


};

function scrollBack(productItemSelector) {
  // Get current page
  var page = parseInt(bcsffilter.queryParams.page);
  // Add id & data-page attribute to item
  jQ(productItemSelector).each(function() {
    if (jQ(this).attr('id') == undefined) {
      var idItem = jQ(this).attr('href').replace(/^_+|_+$|\//g, '') + '-' + page;
      jQ(this).attr('id', idItem);
    }
    if (jQ(this).data('page') == undefined) {
      jQ(this).attr('data-page', page);
    }
  });
  // Change params on the address bar when click to item
  jQ(productItemSelector).click(function(e) {
    var urlW = new URL(window.location.href);

    if (urlW.searchParams.get('page') !== null)
      urlW.searchParams.delete("page");

    if (urlW.searchParams.get('bc-product-current') !== null)
      urlW.searchParams.delete("bc-product-current");

    urlW.searchParams.append('bc-product-current', jQ(this).attr('id'));
    urlW.searchParams.append('page', jQ(this).data('page'));
    
    window.history.pushState('', '', urlW.toString().replace(/\+/g, '%20'));
  });

  // Turn off scroll default  of browser
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }
  // console.log(history.state);
  //if (history.state !== null) {
  var urlW = new URL(window.location.href);
  var itemId = urlW.searchParams.get('bc-product-current');
  if (itemId !== null) {
    urlW.searchParams.delete("bc-product-current");
    if (urlW.searchParams.get('page') == 1) urlW.searchParams.delete("page");
    
    window.history.pushState('', '', urlW.toString().replace(/\+/g, '%20'));
    jQ("html, body").animate({ scrollTop: jQ('#' + itemId).offset().top }, 1000);
  }
  //}
}

// // Build Infinite Loading event
// BCSfFilter.prototype.buildInfiniteLoadingEvent = function(data) {
//     var _this = this;
//     var currentPage = parseInt(this.queryParams.page);

//     // Using scrolling to prevent callling onscroll twice
//     var scrolling = 0;

//     // onscroll event
//     // When windown reaches the bottom of product list
//     var scrollToBottom = false;
//     if (jQ(this.getSelector('bottomPagination')).length > 0) {
//         jQ(window).scroll(function(e) {
//             e.preventDefault();
//             e.stopPropagation();

//             var scrollbarHeight = jQ(window).height() * (jQ(window).height() / jQ(document).outerHeight());
//             var maxPos = parseInt(jQ(_this.getSelector('bottomPagination')).offset().top);
//             var maxScroll = parseInt(jQ(window).scrollTop()) + scrollbarHeight + _this.getSettingValue('general.positionShowInfiniteLoading');
//             if ((jQ(window).scrollTop() + jQ(window).height() + scrollbarHeight) >= jQ(document).outerHeight() - 100) {
//                 scrollToBottom = true;
//             }

//             // Begin loading more products
//             if (scrolling == 0 && data.products.length > 0) {
//                 if (maxScroll >= maxPos || (maxScroll < maxPos && scrollToBottom)) {
//                     // Show Loading
//                     _this.showLoadMoreLoading();

//                     // Prevent scrolling twice
//                     scrolling = 1;

//                     // Next page
//                     currentPage ++;

//                     // Build data of next page
//                     _this.internalClick = true;
//                     _this.queryParams.limit = _this.getSettingValue('general.limit');
//                     _this.queryParams.page = currentPage;
//                     //_this.getFilterData('page');

//                     /******************* Custom *******************/
//                     var newUrl = _this.buildToolbarLink('page', currentPage - 1, currentPage);
//                     _this.onChangeData(newUrl, 'page');
//                 }
//             }
//         });
//     }
// };

// BCSfFilter.prototype.buildLoadMoreEvent = function(data) {
//     var _this = this;
//     var currentPage = parseInt(this.queryParams.page);

//     jQ(this.getSelector('loadMore')).find('a').off('click').on('click', function() {
//         // Hide button
//         jQ(_this.getSelector('loadMoreButtonContainer')).hide();
//         // Show Loading
//         _this.showLoadMoreLoading();

//         // Next page
//         currentPage ++;

//         // Build data of next page
//         _this.internalClick = true;
//         _this.queryParams.limit = _this.getSettingValue('general.limit');
//         _this.queryParams.page = currentPage;

//         /******************* Custom *******************/
//         var newUrl = _this.buildToolbarLink('page', currentPage - 1, currentPage);
//         _this.onChangeData(newUrl, 'page');
//     });


// };




BCSfFilter.prototype.buildFilterTreeMobileButtonEvent = function() {
  var _this = this;
  var filterSelector = this.getSelector('filterTree');
  var mobileBtnSelector = this.getSelector('filterTreeMobileButton');
  jQ(mobileBtnSelector).unbind('click');
  jQ(mobileBtnSelector).on('click', function() {
    var style = _this.mobileStyle;
    // Full Width style
    if (style == 'style2' || style == 'style3') {
      jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
      // Build mobile content
      _this.buildFilterTreeMobile();
      // Remove scrollbar
      _this.removeScrollbar(jQ('.' + _this.class.filterBlockContent));
    }
    // Default style
    else {
      // Change button text when clicking
      if (_this.getSettingValue('general.changeMobileButtonLabel')) {
        var openClass = _this.class.mobileButtonOpen;
        jQ(this).toggleClass(openClass);
        var label = jQ(this).hasClass(openClass) ? _this.getSettingValue('label.refineMobileCollapse') : _this.getSettingValue('label.refineMobile');
        jQ(this).text(label);
      }
      jQ(filterSelector).slideToggle(function() {
        jQ(filterSelector).toggleClass('bc-sf-filter-tree-mobile-open');
        _this.buildFilterOptionBoxStyle(jQ(this));
        // Re-initialize jscrollpane
        _this.buildFilterScrollbar();
      });
    }

    // Custom Hannah
    jQ(this).toggleClass('bc-sf-toggle-btn-filter-mobile');

    jQ('#bc-sf-filter-tree #bc-sf-filter-options-wrapper .bc-sf-filter-option-block:nth-child(2) .bc-sf-filter-block-title').removeClass('bc-sf-toggle-title-option-2');
  });
};


// Build Filter Options selected by parsing params from url
BCSfFilter.prototype.buildFilterSelection = function(data) {
  var selectionContent = this.buildFilterSelectionData(data);
  if (selectionContent !== '') {
    // Build the selection block base on above content
    var selectionWrapperHtml = this.getTemplate('filterRefineWrapper');
    selectionWrapperHtml = selectionWrapperHtml.replace(/{{label.refine}}/g, this.getSettingValue('label.refine'));
    selectionWrapperHtml = selectionWrapperHtml.replace(/{{selectedItems}}/g, selectionContent);
    selectionWrapperHtml = selectionWrapperHtml.replace(/{{clearAllButton}}/g, this.buildClearAllButton());
    selectionWrapperHtml = this.buildFilterTreeClass(selectionWrapperHtml);
    for (var k = 1; k <= this.getSettingValue('general.numberFilterTree'); k++) {
      var filterTreeId = k == 1 ? '' : k;
      if (jQ(window).width() > 768) {
        this.addFilterTreeItem(selectionWrapperHtml, 'before', filterTreeId);
      } else {
        this.addFilterTreeItem(selectionWrapperHtml, 'after', filterTreeId);
      }

    }
  }
};


function sticky_relocate() {
  var window_top = $(window).scrollTop();
  var footer_top = $("#shopify-section-footer").offset().top;
  var div_top = $('#sticky-anchor').offset().top;
  var div_height = $("#bc-sf-filter-tree").height();
  var heightHeader = $(".header-wrapper").height();

  var padding = 20; // tweak here or get from margins etc

  if (window_top + div_height > footer_top - padding)
    jQ('#bc-sf-filter-tree').css({ top: (window_top + div_height - footer_top + padding - heightHeader) * -1 }).addClass('sticky-bottom');
  else if (window_top > div_top) {
    jQ('#bc-sf-filter-tree').addClass('stick').removeClass('sticky-bottom');
    jQ('#bc-sf-filter-tree').css({ top: heightHeader + 20 });
    jQ('#bc-sf-filter-tree').css({ height: 'calc(100% - ' + (heightHeader + 20) + 'px)' });

    // Fixed scroll on Tablet
    jQ(function() {
      jQ('#bc-sf-filter-tree').jScrollPane({
        contentWidth: '0px'
      });
    });
    // End Fixed scroll on Tablet
  } else {
    jQ('#bc-sf-filter-tree').removeClass('stick').removeClass('sticky-bottom');
  }

}

jQ(document).ready(function() {
  //   jQ("#bc-sf-filter-tree").sticky({topSpacing:0});
  //   if(){
  //     jQ('#bc-sf-filter-tree').unstick();
  //   }


});


// Build Default layout
function buildDefaultLink(a,b){var c=window.location.href.split("?")[0];return c+="?"+a+"="+b}BCSfFilter.prototype.buildDefaultElements=function(a){if(bcSfFilterConfig.general.hasOwnProperty("collection_count")&&jQ("#bc-sf-filter-bottom-pagination").length>0){var b=bcSfFilterConfig.general.collection_count,c=parseInt(this.queryParams.page),d=Math.ceil(b/this.queryParams.limit);if(1==d)return jQ(this.selector.pagination).html(""),!1;if("default"==this.getSettingValue("general.paginationType")){var e=bcSfFilterTemplate.paginateHtml,f="";f=c>1?bcSfFilterTemplate.hasOwnProperty("previousActiveHtml")?bcSfFilterTemplate.previousActiveHtml:bcSfFilterTemplate.previousHtml:bcSfFilterTemplate.hasOwnProperty("previousDisabledHtml")?bcSfFilterTemplate.previousDisabledHtml:"",f=f.replace(/{{itemUrl}}/g,buildDefaultLink("page",c-1)),e=e.replace(/{{previous}}/g,f);var g="";g=c<d?bcSfFilterTemplate.hasOwnProperty("nextActiveHtml")?bcSfFilterTemplate.nextActiveHtml:bcSfFilterTemplate.nextHtml:bcSfFilterTemplate.hasOwnProperty("nextDisabledHtml")?bcSfFilterTemplate.nextDisabledHtml:"",g=g.replace(/{{itemUrl}}/g,buildDefaultLink("page",c+1)),e=e.replace(/{{next}}/g,g);for(var h=[],i=c-1;i>c-3&&i>0;i--)h.unshift(i);c-4>0&&h.unshift("..."),c-4>=0&&h.unshift(1),h.push(c);for(var j=[],k=c+1;k<c+3&&k<=d;k++)j.push(k);c+3<d&&j.push("..."),c+3<=d&&j.push(d);for(var l="",m=h.concat(j),n=0;n<m.length;n++)"..."==m[n]?l+=bcSfFilterTemplate.pageItemRemainHtml:l+=m[n]==c?bcSfFilterTemplate.pageItemSelectedHtml:bcSfFilterTemplate.pageItemHtml,l=l.replace(/{{itemTitle}}/g,m[n]),l=l.replace(/{{itemUrl}}/g,buildDefaultLink("page",m[n]));e=e.replace(/{{pageItems}}/g,l),jQ(this.selector.pagination).html(e)}}if(bcSfFilterTemplate.hasOwnProperty("sortingHtml")&&jQ(this.selector.topSorting).length>0){jQ(this.selector.topSorting).html("");var o=this.getSortingList();if(o){var p="";for(var q in o)p+='<option value="'+q+'">'+o[q]+"</option>";var r=bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g,p);jQ(this.selector.topSorting).html(r);var s=void 0!==this.queryParams.sort_by?this.queryParams.sort_by:this.defaultSorting;jQ(this.selector.topSorting+" select").val(s),jQ(this.selector.topSorting+" select").change(function(a){window.location.href=buildDefaultLink("sort_by",jQ(this).val())})}}};

// Customize data to suit the data of Shopify API
BCSfFilter.prototype.prepareProductData=function(data){for(var k=0;k<data.length;k++){data[k]['images']=data[k]['images_info'];if(data[k]['images'].length>0){data[k]['featured_image']=data[k]['images'][0]}else{data[k]['featured_image']={src:bcSfFilterConfig.general.no_image_url,width:'',height:'',aspect_ratio:0}}data[k]['url']='/products/'+data[k].handle;var optionsArr=[];for(var i=0;i<data[k]['options_with_values'].length;i++){optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options']=optionsArr;data[k]['price_min']*=100,data[k]['price_max']*=100,data[k]['compare_at_price_min']*=100,data[k]['compare_at_price_max']*=100;data[k]['price']=data[k]['price_min'];data[k]['compare_at_price']=data[k]['compare_at_price_min'];data[k]['price_varies']=data[k]['price_min']!=data[k]['price_max'];var firstVariant=data[k]['variants'][0];if(getParam('variant')!==null&&getParam('variant')!=''){var paramVariant=data.variants.filter(function(e){return e.id==getParam('variant')});if(typeof paramVariant[0]!=='undefined')firstVariant=paramVariant[0]}else{for(var i=0;i<data[k]['variants'].length;i++){if(data[k]['variants'][i].available){firstVariant=data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant']=firstVariant;for(var i=0;i<data[k]['variants'].length;i++){var variantOptionArr=[];var count=1;var variant=data[k]['variants'][i];var variantOptions=variant['merged_options'];if(Array.isArray(variantOptions)){for(var j=0;j<variantOptions.length;j++){var temp=variantOptions[j].split(':');data[k]['variants'][i]['option'+(parseInt(j)+1)]=temp[1];data[k]['variants'][i]['option_'+temp[0]]=temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options']=variantOptionArr}data[k]['variants'][i]['compare_at_price']=parseFloat(data[k]['variants'][i]['compare_at_price'])*100;data[k]['variants'][i]['price']=parseFloat(data[k]['variants'][i]['price'])*100}data[k]['description']=data[k]['content']=data[k]['body_html']}return data};



/* Start Fix version 2.3.2 */
BCSfFilter.prototype.addFilterTreeItem=function(e,r,t,i){e=jQ.parseHTML(e),i=void 0!==i?i:this.getSelector("filterTree");void 0!==r&&"before"==r?jQ(i+t).prepend(e):jQ(i+t).append(e)};
/* End Fix version 2.3.2 */

// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};


BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* start-boost-2.4.8 */
BCSfFilter.prototype.buildFilterOptionItem=function(html,iLabel,iValue,fOType,fOId,fOLabel,fODisplayType,fOSelectType,fOItemValue,fOData){var keepValuesStatic=fOData.hasOwnProperty("keepValuesStatic")?fOData.keepValuesStatic:false;if(fOType=="review_ratings"&&this.getSettingValue("general.ratingSelectionStyle")=="text"){var title=this.getReviewRatingsLabel(fOItemValue.from)}else{var title=this.customizeFilterOptionLabel(iLabel,fOData.prefix,fOType)}if(keepValuesStatic===true)var productNumber=null;else var productNumber=fOItemValue.hasOwnProperty("doc_count")?fOItemValue.doc_count:0;html=html.replace(/{{itemLabel}}/g,this.buildFilterOptionLabel(iLabel,productNumber,fOData));html=html.replace(/{{itemLink}}/g,this.buildFilterOptionLink(fOId,iValue,fOType,fODisplayType,fOSelectType,keepValuesStatic));html=html.replace(/{{itemValue}}/g,encodeURIParamValue(iValue));html=html.replace(/{{itemTitle}}/g,title);html=html.replace(/{{itemFunc}}/g,"onInteractWithFilterOptionValue(event, this, '"+fOType+"', '"+fODisplayType+"', '"+fOSelectType+"', '"+keepValuesStatic+"')");html=this.checkFilterOptionSelected(fOId,iValue,fOType,fODisplayType)?html.replace(/{{itemSelected}}/g,"selected"):html.replace(/{{itemSelected}}/g,"");var htmlElement=jQ(html);htmlElement.children().attr({"data-id":fOId,"data-value":encodeURIParamValue(iValue),"data-parent-label":fOLabel,"data-title":title,"data-count":productNumber});if(fOType!="collection"){htmlElement.children().attr("rel","nofollow")}if(fOType=="collection")htmlElement.children().attr("data-collection-scope",fOItemValue.key);return jQ(htmlElement)[0].outerHTML};
/* end-boost-2.4.8 */

/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
